import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { AuthenticationService } from '@app-auth/services/authentication.service';
import { LoginPageUtilService } from '@app-auth/services/login-page-util.service';
import { SUPPORTED_LANGUAGES } from '@app-core/constants/constants';
import { CognitoRegionType } from '@app-core/models/core.model';
import { CookieService } from '@app-core/services/cookie/cookie.service';
import { SnackBarService } from '@app-core/services/snackbar/snack-bar.service';
import { FooterDirective } from '@app-shared/directives/footer/footer.directive';
import { CLIENT_CONFIG } from '@config/config';
import { environment } from '@env/environment';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss'],
})
export class LandingPageComponent implements OnInit, OnDestroy {
  @ViewChild(FooterDirective, { static: true }) footerHost: FooterDirective;

  public clientConfig = CLIENT_CONFIG;
  public copyrightyear = new Date().getFullYear();
  public regions: CognitoRegionType[] = [];
  public regionControl = new FormControl(
    { value: '', disabled: this.clientConfig.landingPageDetails.disableRegionSelection },
    Validators.required
  );
  public showRegionSelection =
    Boolean(CLIENT_CONFIG.landingPageDetails.defaultUserCountry) || Object.keys(environment.cognitoConfigs || {}).length > 1;
  private destroy$ = new Subject<void>();

  public supportedLanguages = SUPPORTED_LANGUAGES;
  public languageControl = new FormControl('');

  constructor(
    private authService: AuthenticationService,
    private loginUtilService: LoginPageUtilService,
    private snackBarService: SnackBarService,
    private cookieService: CookieService,
    public translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.getRegionValue();
    //this.getLanguageValue();
    this.setEnglishLanguage();

    this.cookieService.deleteAllCookies();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public onSignIn() {
    const selectedRegion = this.regionControl.value;
    if (!selectedRegion && this.showRegionSelection) {
      this.snackBarService.failure(this.translate.instant('customLoginSelectRegionError'));
      return;
    }
    this.authService.authorizeUser();
  }

  public getRegionValue() {
    const { regions, previouslySelectedRegion } = this.loginUtilService.getRegionValue();
    this.regions = regions;
    if (previouslySelectedRegion) {
      this.regionControl.patchValue(previouslySelectedRegion);
    }

    this.regionControl.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((selectedRegion) => {
      this.loginUtilService.regionChanged(selectedRegion);
    });
  }

  public getLanguageValue() {
    const currentLanguage = this.loginUtilService.getCurrentLanguage();
    this.languageControl.patchValue(currentLanguage);

    this.languageControl.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((selectedLanguage) => {
      if (selectedLanguage) {
        this.loginUtilService.languageChanged(selectedLanguage);
      }
    });
  }

  public setEnglishLanguage() {
    !this.clientConfig.showCustomLoginPage && this.translate.use('en');
  }
}
